import React, { useState } from 'react'
import styled from 'styled-components'
import {
  CloseButton,
  Flex,
  Link,
  Text,
  getPaletteColor,
  Image
} from 'pcln-design-system'
import { ChevronRight } from 'pcln-icons'
import { Referral } from '@/types'
import useSeti from '@/hooks/useSeti'
import { getLink } from './utils'

const COOKIE_MAX_AGE = 2592000 // 30 Days

const Container = styled(Flex)`
  display: flex;
  background-color: #002f6b;
  color: ${getPaletteColor('text.lightest')};
  padding: 10px;
  @media (min-width: 400px) {
    padding-right: 24px;
  }
`

const StyledLink = styled(Link)`
  flex: 1 1 auto;
  display: flex;
  &:active,
  &:focus,
  &:visited,
  &:hover {
    color: ${getPaletteColor('text.lightest')};
    text-decoration: none;
  }
`

const appIconUrl =
  'https://s1.pclncdn.com/design-assets/brand-assets/app-icon.svg'

type AppBannerProps = {
  isAndroid: boolean
  titleText: string
  contentText: string
  pageId: string
  referral: Referral | Record<string, never>
  clientGUID: string
}

export default function AppBanner({
  isAndroid,
  titleText,
  contentText,
  pageId,
  referral,
  clientGUID
}: AppBannerProps) {
  const [isBannerVisible, setBannerVisible] = useState(true)

  const closeAppBanner = () => {
    setBannerVisible(false)
    document.cookie = `hideAppBanner=true; domain=.priceline.com; path=/; max-age=${COOKIE_MAX_AGE};`
  }

  const appBannerDefault =
    useSeti('MBL_HP_APP_BANNER_REDESIGN', false) === 'DEFAULT'

  return isBannerVisible ? (
    <Container id="app-download-banner" className="app-banner" fontSize={0}>
      <Flex alignItems="center">
        <CloseButton
          size={16}
          id="closeBannerBtn"
          data-ga-category="PCLN_HOME"
          data-ga-action="App_Banner"
          data-ga-label="dismiss"
          title="dismiss app banner"
          onClick={closeAppBanner}
        />
      </Flex>
      <StyledLink
        color="text.lightest"
        href={getLink(
          isAndroid,
          referral,
          clientGUID,
          `${appBannerDefault ? `${pageId}_v3` : `${pageId}_v6`}`
        )}
        data-testid="DASH_MWEB_TAB_GET_APP"
        data-ga-category="PCLN_HOME"
        data-ga-action="App_Banner"
        data-ga-label="click to launch"
      >
        <Flex alignItems="flex-start" px={12} py={0}>
          <Image src={appIconUrl} alt="Priceline Icon" />
        </Flex>
        <Flex flexDirection="column" justifyContent="center">
          <Text fontWeight="bold" fontSize={15} lineHeight="19px" mb={1}>
            {titleText}
          </Text>
          <Text fontSize={13} lineHeight="12px">
            {contentText}
          </Text>
        </Flex>
        <Flex alignItems="center" ml="auto">
          <ChevronRight
            title="click to launch app"
            color="text.lightest"
            size={20}
          />
        </Flex>
      </StyledLink>
    </Container>
  ) : null
}
